<template>
	<div class="categ_info" v-if="obj_to_null(this.rest)">
		<info_field f_uniq="ct"
					f_type="title"
					:is_disabled="false"
					@update_categ="change_atr"
					:f_title="__t('NAME')"
					:f_val="cur_rest.title">

		</info_field>

        <div class="form-group mt-2 mb-4" v-if="is_iiko_cloud">

            <div class="mb-4">
                <label class="form-label" for="iiko_actions">
                    {{__t("IIKO_ACTION")}}
                </label>

                <div class="" v-if="syrve_actions.length > 0">
                    <v-select v-model="cur_rest.action_id"
                              class="imc_reasons"
                              label="name"
                              :reduce="action => action.id"
                              id="iiko_actions"
                              :options="this.syrve_actions"
                              :filterable="false"
                    >
                        <template slot="no-options">
                            {{__t("CHOICE_SYRVE_ACTION")}}
                        </template>

                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                <div>
                                    {{ option.name }}
                                </div>
                                <div>
                                    <small>
                                        {{option.id}}
                                    </small>
                                </div>
                            </div>
                        </template>
                    </v-select>
                </div>
            </div>

            <label class="form-label" for="iiko_menu">
                {{__t("IIKO_MENU")}}
            </label>

            <div class="" v-if="prices_types.length > 0">
                <v-select v-model="active_menu_id"
                          class="imc_reasons"
                          label="name"
                          :options="this.prices_types"
                          :filterable="false"
                >
                    <template slot="no-options">
                        {{__t("CHOICE_REST")}}
                    </template>

                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            <div>
                                {{ option.name }}
                            </div>
                            <div>
                                <small>
                                    {{option.id}}
                                </small>
                            </div>
                        </div>
                    </template>
                </v-select>
            </div>
        </div>


		<info_field f_uniq="cid" 	@update_categ="change_atr" :f_title="__t('UNIQ_GO_CODE')"  :f_val="cur_rest.id.toString()"></info_field>
		<info_field f_uniq="cid2" f_type="uniq_id" 	:is_disabled="false" 	@update_categ="change_atr"  :f_title="__t('UNIQ_CODE')"  :f_val="cur_rest.uniq_id.toString()"></info_field>

        <div class="micros_block mt-2 mb-4 border-2 border border-primary  bg-faded p-3" v-if="is_micros">
            <info_field f_uniq="micros_url" f_type="micros_url" 	:is_disabled="false" 	@update_categ="change_atr"  :f_title="__t('MICROS_SOAP_URL')"
                        :f_val="cur_rest.micros_url.toString()">
            </info_field>
        </div>

        <div class="smart_block" v-if="is_smart">
            <info_field f_uniq="smart_url" f_type="smart_url" 	:is_disabled="false" 	@update_categ="change_atr"  :f_title="__t('SMART_URL')"
                        :f_val="cur_rest.smart_url.toString()">
            </info_field>


            <info_field f_uniq="smart_username" f_type="smart_username" 	:is_disabled="false" 	@update_categ="change_atr"  :f_title="__t('SMART_USERNAME')"
                        :f_val="cur_rest.smart_username.toString()">
            </info_field>


            <info_field f_uniq="smart_password" f_type="smart_password" 	:is_disabled="false" 	@update_categ="change_atr"  :f_title="__t('SMART_PASS')"
                        :f_val="cur_rest.smart_password.toString()">
            </info_field>
        </div>

        <info_field f_uniq="cid3" f_type="address" 	@update_categ="change_atr" 	:is_disabled="false" :f_title="__t('REST_ADDRESS')"  :f_val="cur_rest.address.toString()"></info_field>
        <info_field f_uniq="cid34" f_type="phone" 	@update_categ="change_atr" 	:is_disabled="false" :f_title="__t('REST_PHONE')"  :f_val="cur_rest.phone.toString()"></info_field>

		<info_field f_uniq="cid3" f_type="lat"		@update_categ="change_atr" :is_disabled="false" :f_title="__t('REST_LAT')"  :f_val="cur_rest.lat.toString()"></info_field>
		<info_field f_uniq="cid3" f_type="lng"		@update_categ="change_atr" :is_disabled="false" :f_title="__t('REST_LNG')"  :f_val="cur_rest.lng.toString()"></info_field>

        <div class="user_descr mb-4">
            <label class="form-label" for="rest_description">
                {{ __t('REST_DESCRIPTION') }}
            </label>

            <b-form-textarea
                id="textarea"
                v-model="cur_rest.description"
                placeholder="Delivery Description"
                rows="3"
                max-rows="6"
            ></b-form-textarea>
        </div>



		<div class="form-group">
			<label class="form-label" for="name-f">{{__t("DATE_CREATE")}}</label>
			<div class="input-group">
				<div class="input-group-prepend">
						<span class="input-group-text text-success">
							<i class="fal fa-calendar-edit fs-xl"></i>
						</span>
				</div>
				<input type="text" class="form-control" id="name-f" disabled v-model="cur_rest.added">
				<input type="text" class="form-control" id="name-l" disabled v-model="cur_rest.updateAt">
			</div>
		</div>
	</div>
</template>

<script>
import Info_field from "../../../../sys/info_field.vue";
import vSelect from 'vue-select'
export default {
	name: "restaurant_info",
	components: {Info_field,vSelect},
	props : {
		rest : {
			type : Object
		}
	},
	data() {
		return {
		    prices_types  : [],
            syrve_actions : [],
			cur_rest : this.rest,
			is_load: false,
		}
	},

    created() {
        if(this.is_iiko_cloud){
            this.load_iiko_menus();
            this.load_iiko_actions();
        }

    },

	methods :  {
		change_atr(atr_name,atr_val) {
			if(this.rest.hasOwnProperty(atr_name)) {
				this.rest[atr_name] = atr_val;
			}
		},

        async load_iiko_actions() {
            await pos_api.get('/'+ this.pos_provider +'/restaurants/' + this.rest.id +'/actions',{}).then(({data}) => {
                if (data.status === "operation_success") {
                    this.syrve_actions = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        async load_iiko_menus() {
            this.ext_restaurants = [];
            await pos_api.get('/'+ this.pos_provider +'/menus',{}).then(({data}) => {
                if (data.status === "operation_success") {
                    this.prices_types = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
	},
	computed : {


        pos_provider () {
            return this.rest?.pos_provider ?? '';
        },

        active_menu_id : {
            get :function () {
                let active = null;
                if(this.prices_types.length > 0) {
                    if(this.rest.hasOwnProperty("menu_price_id")) {
                        this.prices_types.map(item => {
                            if(parseInt(item.id) === parseInt(this.rest.menu_price_id)) {
                                active = item;
                            }
                        })
                    }
                }

                return active;
            },

            set: function (val){
                if(val != null) {
                    if (this.rest.hasOwnProperty("menu_price_id")) {
                        this.change_atr("menu_price_id",val.id)
                        this.rest.menu_price_id = val.id;
                    }
                }
                else {
                    if (this.rest.hasOwnProperty("menu_price_id")) {
                        this.rest.menu_price_id = 0;
                        this.change_atr("menu_price_id",0)
                    }
                }
            },
        },


        is_iiko_cloud () {
            try {
                return this.rest.has_price_menu;
            }
            catch (e) {
                console.log(e);
            }
            return false;
        },
		is_disabled () {
			return this.rest.id > 0;
		},

        is_smart() {
		    return this.rest.provider == 'smarttouch_sub';
        },

        is_micros() {
            return this.rest.provider == 'sub_micros';
        }

	},
}
</script>

<style scoped>

</style>
